import { useInstitutionsStore } from '@/stores/institutions';
import { redirectToInstitution } from '@/utils/institutionsUtils';
import { useCallback } from 'react';

/**
 * Returns a function that triggers a full page reload to switch the current institution.
 * All institution switches (same or cross-subdomain) perform a redirect to the login page
 * with the target institution's ID and current authentication token.
 * @returns Institution change handler accepting an ID and optional returnPath.
 */
export const useInstitutionChange = () => {
  const { currentInstitution, getInstitutionById } = useInstitutionsStore(
    (state) => ({
      currentInstitution: state.currentInstitution,
      getInstitutionById: state.getInstitutionById,
    }),
  );
  const handleInstitutionChange = useCallback(
    (id: string, redirect?: string) => {
      const institution = getInstitutionById(id);
      if (
        !institution ||
        !currentInstitution?.id ||
        institution.id === currentInstitution.id
      )
        return;

      redirectToInstitution({
        currentInstitution,
        targetInstitution: institution,
        redirect,
      });
    },
    [currentInstitution, getInstitutionById],
  );

  return handleInstitutionChange;
};
